module.exports = __webpack_public_path__ + "static/media/mapa_gcba.e8206776.jpg";